<script lang="ts" setup>
import { useState } from '#app'
import { ref, watch } from 'vue'
import type { CmsData, CmsCustomComponentType, CustomComponentValue } from '~/layers/cms/app/types/cmsTypes'
import { getByPath } from '../../utils/cmsDataHelper'

const cmsData = useState<CmsData>('cmsData')

const props = defineProps<{
  cmsDataPath: (string | number)[]
  defaults?: CmsCustomComponentType
  componentName: string
  openOptions?: boolean
  global?: boolean
}>()

const merged_values = ref<CmsCustomComponentType>({} as CmsCustomComponentType)

type PropsDefaults = Record<string, CustomComponentValue>

watch(() => getByPath(cmsData.value, [...props.cmsDataPath])?.component_data as CmsCustomComponentType | undefined, (newCmsValues) => {
  if (!newCmsValues) return
  const defaults = props.defaults ?? {} as CmsCustomComponentType
  const merged: CmsCustomComponentType = { ...newCmsValues }

  Object.keys(defaults).forEach((key) => {
    const defaultVal = (defaults as PropsDefaults)[key]
    const cmsVal = newCmsValues[key]
    merged[key] = (cmsVal ? { ...defaultVal, ...cmsVal } : defaultVal) as CustomComponentValue
  })

  merged_values.value = merged
}, { immediate: true, deep: true })
</script>

<template>
  <div v-cms-custom-component:[merged_values]="{ path: [...props.cmsDataPath], componentName: props.componentName, openOptions: props.openOptions ?? false, defaultValues: defaults, global: props.global }">
    <slot :component_values="merged_values" />
  </div>
</template>
